import { render, staticRenderFns } from "./FavoriteGridSkeleton.vue?vue&type=template&id=2843f210&scoped=true&"
import script from "./FavoriteGridSkeleton.vue?vue&type=script&lang=js&"
export * from "./FavoriteGridSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteGridSkeleton.vue?vue&type=style&index=0&id=2843f210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2843f210",
  null
  
)

export default component.exports